export default __webpack_public_path__ + "static/media/five.a5674621.glb";